


import * as React from "react";
import { Button } from "reactstrap";
/** Presentation */
/** Custom Hooks */
import { useAuth } from "../../../Services/AuthContext";
import { endpoints } from "../../../utils/Constants";
import LoadingAnimation from "../../Form/LoadingAnimation";
import { useRefreshToken } from "../../../Services/fetchRefresh";
import IFrameContainer from "../../Editors/IFrameContainer";
import { useAlert } from "../../../Services/AlertContext";
import useFetchSimple from "../../../Services/useFetchSimple"; 
import useFetch from "../../../Services/useFetch";

const TermsPanel = ({ notUser, type }) => {
    const [terms, loading, error] = useFetch(notUser ? endpoints.getTermsAndConditions + '/' + type : endpoints.getAccountTermsAndConditions);
    const [, dispatchSetuser] = useAuth();
    const [saving, setSaving] = React.useState();
    const alert = useAlert();
    const fetch = useFetchSimple();
    const refreshToken = useRefreshToken();
    const logout = () => {
        dispatchSetuser({
            type: "removeAuthDetails"
        });
    }
    const acceptTerms =async  () => {
        const options = {
            method: 'POST', body:'"'+ terms.id+'"' };
        setSaving(true);
      
        try {
            var result = await fetch(endpoints.acceptTerms, options);
            const ret = result.body;
            if (ret.success) {
                refreshToken();
            }
            else {
                alert({

                    title: "Error", body: <div>
                        <h5>Error Accepting Terms</h5>
                        {ret.messages && ret.messages.length ? ret.messages.map(x => <p>{x}</p>) : null}
                    </div>
                    , onDismiss: () => {

                        setSaving(false);

                    }
                });

            }
        }
        catch (e) {
            alert({

                title: "Error", body: JSON.stringify(e)
                , onDismiss: () => {

                    setSaving(false);

                }
            });
        }

    }
    const accept = () => {
        notUser ? console.log("terms accepted"): acceptTerms();
    }
    return (
        <React.Fragment>


            {notUser ? null : <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'centre' }}>
                <img alt='jetbidders' src={'/img/logo.png'} style={{ width: '60%', height: 'auto', marginTop: '5vh', marginBottom: '5vh' }} />
            </div>}
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'centre'}}>
                <div style={{ width: '80%' , backgroundColor:'white'}}>
                    <h3>{terms?.label}</h3>
                    {loading ? <LoadingAnimation /> : <IFrameContainer content={terms?.terms} />}
                    {error ? <h5>Error Loading</h5> : null}
                </div>
            </div>
            {notUser ? null:<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                {!loading ? <div style={{ marginTop: '1vh', marginBottom: '1vh', width: '80%', display: 'flex', justifyContent: 'space-between' }}>

                    <Button color="secondary" onClick={logout}>No Thanks...</Button>
                    <Button color='primary' disabled={loading} onClick={accept}>
                        {saving ? "Loading..." : "Accept Terms"}
                    </Button>
                </div>
                    : null}
            </div>}
        </React.Fragment>
    );
}

export default TermsPanel;